<template>
  <div
    class="wiki"
    :style="{
      backgroundColor: `${$props.backgroundColor}`,
    }"
  >
    <p class="title">wiki</p>

    <div class="flex">
      <div>agent_id:</div>
      <div>{{ _id }}</div>
    </div>

    <div class="flex">
      <div>type:</div>
      <div>{{ _type }}</div>
    </div>

    <div class="flex">
      <div>born_at:</div>
      <div>{{ _birthDate }}</div>
    </div>

    <div class="flex">
      <div>size:</div>
      <div>{{ _size }}</div>
    </div>

    <div class="flex">
      <div>locate:</div>
      <div>{{ _locate }}</div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import _ from 'lodash';

export default {
  props: {
    agent: Object,
    backgroundColor: String,
  },
  computed: {
    _isEmpty() {
      return _.isEmpty(this.$props.agent);
    },
    _id() {
      return this._isEmpty ? '-' : `0000${this.$props.agent.id}`;
    },
    _type() {
      return this._isEmpty ? '-' : this.$props.agent.type;
    },
    _birthDate() {
      return this._isEmpty ? '-' : format(this.$props.agent.birthDate, 'HH:mm:ss.SSS');
    },
    _size() {
      return this._isEmpty ? '-' : `${this.$props.agent.width}px, ${this.$props.agent.height}px`;
    },
    _locate() {
      return this._isEmpty ? '-' : `${_.round(this.$props.agent.x, 2)}, ${_.round(this.$props.agent.y, 2)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.wiki {
  position: absolute;
  top: 10px;
  right: 13px;
  width: 144px;
  margin: 10px;

  text-align: left;
  font-size: 10px;
  letter-spacing: 1px;
  color: #070751;

  z-index: 2;

  @include sp {
    display: none;
  }

  @include spLandscape {
    display: none;
  }

  @include tbLandscape {
    display: none;
  }
}

.title {
  font-weight: 500;
  margin-bottom: 12px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>
